import React from 'react';
import { Tag } from 'tags/models/tagsApi.types';
import { TagDisplay } from 'tags/TagsDisplay';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { CHIPS_HEIGHTS_MAP } from 'theme/components/MuiChip';
import { CellLayout } from './CellLayout';

type TagsCellProps = {
  tags?: Tag[];
  hasMore?: boolean;
  id: string;
};

const TagsCellRoot = styled(Box, {
  name: 'TagsCell',
  slot: 'root',
})(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  lineHeight: theme.spacing(CHIPS_HEIGHTS_MAP.MEDIUM),
}));

export const TagsCell: React.FC<TagsCellProps> = React.memo(
  ({ tags = [], id, hasMore = false }) => {
    if (!tags.length) {
      return <CellLayout>-</CellLayout>;
    }

    return (
      <TagsCellRoot>
        <TagDisplay initialTags={tags.map((tag: Tag) => tag.name)} id={id} hasMore={hasMore} />
      </TagsCellRoot>
    );
  },
);
